<script>
    import Pages from '../../pages';
    import router from '../../router';
    import state from '../../state';

    let pageIndexes = {};
    let i = 0;
    for (let page of Pages) {
        pageIndexes[page.key] = i;
        i++;
    }

    function go(step) {
        let next = 0;
        if (pageIndexes.hasOwnProperty($state.page)) {
            next = pageIndexes[$state.page];
            next += step;

            if (next < 0) {
                next = Pages.length - 1;
            } else if (next > Pages.length - 1) {
                next = 0;
            }
        }

        let page = Pages[next];
        router.nav.navigate(page.path);
    }
</script>

<style>
    .lmpixels-arrows-nav {
        position: absolute;
        padding: 10px 0;
        width: 60px;
        right: -80px;
        background-color: #444;
        border-radius: 35px;
        z-index: 98;
        list-style: none;
        bottom: 0;
        -webkit-box-shadow: 0 0 30px -5px rgba(0, 0, 0, .15);
        -moz-box-shadow: 0 0 30px -5px rgba(0, 0, 0, .15);
        box-shadow: 0 0 30px -5px rgba(0, 0, 0, .15);
    }

    .lmpixels-arrows-nav div {
        display: block;
        position: relative;
        text-align: center;
        color: #b5b6b7;
        padding: 10px;
        font-size: 24px;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
    }

    .lmpixels-arrows-nav div:hover {
        color: #5050f5;
    }

    @media only screen and (max-width: 1024px) {
        .lmpixels-arrows-nav {
            background-color: rgba(0,0,0,.6);
            width: 48px;
            right: 10px;
            bottom: 10px;
            padding: 5px 0;
            border: 2px solid #5050f5;
        }

        .lmpixels-arrows-nav div {
            font-size: 24px;
        }
}
</style>

<div class="lmpixels-arrows-nav">
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="lmpixels-arrow-right" onclick={() => go(1)}>
        <i class="lnr lnr-chevron-right"></i>
    </div>

    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="lmpixels-arrow-left" onclick={() => go(-1)}>
        <i class="lnr lnr-chevron-left"></i>
    </div>
</div>